export default __webpack_public_path__ + "fcd6b3c736616218709bf8c070316e57.png";